import { SectionHeader } from "@/components/ui/SectionHeader";
import { MetricGrid, type MetricItem } from "@/components/ui/MetricGrid";

const OVERVIEW_METRICS: MetricItem[] = [
  {
    metric: "JPY ⇄ ステーブルコイン",
    label: "双方向の発行・償還",
    detail: "日本円の入金でステーブルコインを発行（Intent）、ステーブルコインの送付でJPYを払い戻し（Redemption）",
  },
  {
    metric: "1 ステーブルコイン = 1 JPY",
    label: "明快なレート設計",
    detail: "現行は 1 ステーブルコイン = 1 JPY の固定換算。複雑なレート管理が不要",
  },
  {
    metric: "End-to-End",
    label: "認証から送金まで一気通貫",
    detail: "セッション認証・2FA・入金照合・オンチェーン送金・払い戻しまで一括管理",
  },
];

export function MbscOverview() {
  return (
    <section className="px-6 py-20 md:px-12">
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          eyebrow="Overview"
          title="日本円 ↔ ステーブルコイン間の発行・償還を、API ひとつで。"
          description="MBSC は、銀行振込による日本円入金から自社 ステーブルコイン（ERC-20）の発行、
            そして ステーブルコイン 送付による日本円払い戻しまでを一貫して処理するバックエンドです。
            バーチャル口座の発行、入金照合、オンチェーン送金、銀行振込による返金——
            複雑なオペレーションはすべて MBSC が吸収します。"
        />
        <MetricGrid items={OVERVIEW_METRICS} className="mt-14" />
      </div>
    </section>
  );
}
